// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__On5X1","description":"Welcome_description__C03Mh"};